import type { ReactNode } from 'react'

import styles from './ComposerStack.module.scss'

interface Props {
  children: ReactNode
}

/**
 * Visual wrapper that fuses the context chip bar and the SDK ChatComposer
 * into a single rounded panel. Used on chat surfaces that opt into context
 * tagging; the proposal-editor surface keeps the SDK composer's native panel.
 *
 * Carries a stable `data-ftue-step` anchor so the FTUE kit can frame the
 * whole rounded panel (chip bar + composer) as a single spotlight target.
 * The SDK's own class names are hashed at build time, so a data attribute
 * is the only reliable hook here.
 */
export function ComposerStack({ children }: Props) {
  return (
    <div className={styles.stack} data-ftue-step="chat-composer">
      {children}
    </div>
  )
}
